import { BrandInfoProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoProps";
import { productTileBrandLinkPropsAdapter } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/Links/SearchProductTileBrandLinkProps";
import {
  DiscoveryProductTileBrandInfo,
  discoveryProductTileBrandInfoParamsBrandInfoPropsAdapter,
} from "@faire/retailer-visitor-shared/features/MarketplaceItems/ProductDetailsTile/DiscoveryProductTileBrandInfo";
import React from "react";

interface IProps {
  data: BrandInfoProps;
}

export const BrandInfo: React.FC<IProps> = ({ data }) => {
  const brandLinkProps = productTileBrandLinkPropsAdapter(data);
  if (!data) {
    return null;
  }

  return (
    <DiscoveryProductTileBrandInfo
      brand={discoveryProductTileBrandInfoParamsBrandInfoPropsAdapter(data)}
      shouldUseClickContext
      isLoggedInRetailer={data.isLoggedInRetailer}
      dataTestId={data.dataTestId}
      isLoaded={!!data}
      avgBrandReviewRating={data.avgBrandReviewRating}
      brandReviewCount={data.brandReviewCount}
      brandPromoText={data.brandPromoText}
      insiderBadgeProps={data.insiderBadgeProps}
      isHighlightedProductForPromotionalEvent={
        data.isHighlightedProductForPromotionalEvent
      }
      selectedProductOptionToken={data.selectedProductOptionToken}
      brandLinkProps={brandLinkProps}
      shouldHidePriceProminencePriceTestV3={
        data.shouldHidePriceProminencePriceTestV3
      }
    />
  );
};
